import styled from "styled-components";

import { colors, media } from "../../common/utils/style";
import Link from "../../common/components/router/Link";
import { NavigatableSection as _NavigatableSection } from "../../common/components/SectionNavigator";

export const Section = styled.section`
  margin-top: 60px;
  padding: 0 16px;
  &:first-of-type {
    margin-top: 0;
  }
  @media ${media.large} {
    width: 980px;
    margin: 100px auto 0;
    padding: 0;
  }
`;

export const NavigatableSection = styled(_NavigatableSection)`
  margin-top: 60px;
  &:first-of-type {
    margin-top: 0;
  }
  @media ${media.large} {
    margin: 100px auto 0;
  }
`;

export const SectionInner = styled.div`
  margin: 0 16px;
  @media ${media.large} {
    width: 980px;
    margin: 0 auto;
  }
`;

export const SectionTitle = styled.h2`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
  color: ${colors.gray1};
  margin-bottom: 30px;
  @media ${media.large} {
    font-size: 20px;
    margin-bottom: 40px;
  }
`;

export const SectionLink = styled(Link)`
  margin-left: auto;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.4);
  transition: color 100ms;
  &:hover {
    text-decoration: none;
    color: ${colors.gray4};
  }
`;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/Section.tsx